import React from "react";
import "./style.scss";
import { Col, Row, Modal } from "react-bootstrap";
import ReactPlayer from "react-player/youtube";
import closebutton from "../../images/homepage/closebutton.svg";
import useWindowDimensions from "../../useWindowDimensions";

const KitchenModal = (props) => {
  const { width, height } = useWindowDimensions();

  return (
    // <Modal {...props} size="lg" centered>
    //   <Modal.Body>
    //     <img
    //       src={closebutton}
    //       onClick={props.onHide}
    //       className="ytclosebutton"
    //     />
    //     <ReactPlayer
    //       url={props.youtubeVideo}
    //       width={`${width < 767 ? "100%" : null}`}
    //       height={`${width < 767 ? "100%" : null}`}
    //       // width="640px"
    //       // height="360px"
    //       playing="true"
    //       controls="true"
    //     />
    //   </Modal.Body>
    // </Modal>
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      contentClassName="modalBg"
      keyboard={true}
    >
      <Modal.Header className="justify-content-center">
        <img
          src={process.env.PUBLIC_URL + "/images/closeModal.svg"}
          alt="close-modal"
          className="closeModal"
          onClick={props.onHide}
        />
      </Modal.Header>
      <Modal.Body>
        <ReactPlayer
          url={props.youtubevideo}
          className="video-player"
          playing={true}
          controls={true}
        />
      </Modal.Body>
    </Modal>
  );
};

export default React.memo(KitchenModal);
